/**
 * AntdProvider - antd 配置包装器
 *
 * 提供 antd 组件的主题和样式配置。
 * 使用 CSS-in-JS 变量模式，确保外部样式可覆盖。
 */
import React from 'react'
import { ConfigProvider, App } from 'antd'
import type { ConfigProviderProps } from 'antd'
import zhCN from 'antd/locale/zh_CN'

// 主题配置
const theme: ConfigProviderProps['theme'] = {
  // 使用 CSS 变量模式，便于外部样式覆盖
  // 空对象启用默认 CSS 变量前缀
  cssVar: {},
  // 禁用 hash，确保类名稳定可预测
  hashed: false,
  token: {
    // 主色调
    colorPrimary: '#0093FF',
    // 圆角配置
    borderRadius: 4
  }
}

interface AntdProviderProps {
  children: React.ReactNode
}

/**
 * AntdProvider 组件
 *
 * 使用方式：
 * ```tsx
 * import { Button } from 'antd'
 *
 * function MyComponent() {
 *   return (
 *     <AntdProvider>
 *       <Button type="primary">antd 按钮</Button>
 *     </AntdProvider>
 *   )
 * }
 * ```
 *
 * 也可以在页面级别包裹整个内容区域。
 */
export function AntdProvider({ children }: AntdProviderProps) {
  return (
    <ConfigProvider theme={theme} locale={zhCN}>
      {/* App 组件提供 message/notification/modal 的静态方法 */}
      <App>{children}</App>
    </ConfigProvider>
  )
}

export default AntdProvider
